import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineProDataListItem, HotlineProDataListItemSkeleton, } from '@/feature/hotline/professional/list/component/HotlineProDataList/HotlineProDataListItem';
import { hotlineProDataListStyle } from '@/feature/hotline/professional/list/component/HotlineProDataList/style';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
/**
 * ホットライン相談一覧コンポーネント
 */
export const HotlineProDataList = (props) => {
    const { className = '', isLoading, list } = props;
    const style = hotlineProDataListStyle();
    const dummies = useArrayWithIndex(3);
    // ローディング中
    if (isLoading && !list) {
        return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: dummies.map(({ index }) => (_jsx(HotlineProDataListItemSkeleton, {}, index))) })));
    }
    // データが取得できなかった場合
    if (!list) {
        return (_jsx("div", Object.assign({ className: style.noDataBase({ class: className }) }, { children: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u6642\u9593\u3092\u7F6E\u3044\u3066\u304B\u3089\u3084\u308A\u76F4\u3059\u304B\u3001\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002" })));
    }
    // 0件の場合
    if (!list.length) {
        return (_jsx("div", Object.assign({ className: style.noDataBase({ class: className }) }, { children: "\u73FE\u5728\u3001\u76F8\u8AC7\u306F\u3042\u308A\u307E\u305B\u3093" })));
    }
    // 通常表示
    return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: list.map((item) => (_jsx(HotlineProDataListItem, { item: item }, item.id))) })));
};
